/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Apis_Badge_Per_UserInputs */



/**
* | output |
* | --- |
* | "Own credentials" |
*
* @param {Integrations_Apis_Badge_Per_UserInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_apis_badge_per_user = /** @type {((inputs?: Integrations_Apis_Badge_Per_UserInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Apis_Badge_Per_UserInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eigene Zugangsdaten")
	return /** @type {LocalizedString} */ ("Own credentials")
});